import {
  LANGUAGE_CHANGE_FAILURE,
  LANGUAGE_CHANGE_SUCCESS,
} from '../actions/type';
import StorageService from '../services/storage.service';

const language = StorageService.getObject('language');

const initialState = {
  language: typeof language === 'string' ? language.toLowerCase() : 'en',
  error: null,
};

const languageReducer = (state = initialState, action) => {
  switch (action.type) {
    case LANGUAGE_CHANGE_SUCCESS:
      return {
        ...state,
        language:
          typeof action.payload === 'string'
            ? action.payload.toLowerCase()
            : state.language,
        error: null,
      };
    case LANGUAGE_CHANGE_FAILURE:
      return {
        ...state,
        error: 'Failed to change language',
      };
    default:
      return state;
  }
};

export default languageReducer;
